export default "__VITE_ASSET__38efc18e__"